export enum VehicleType {
  BICYCLE = 'Bicycle',
  ELECTRIC_BIKE = 'Electric bike',
  CAR = 'Car',
  MOTOR_BIKE = 'Motor bike'
}